<template>
  <div class="servitor_demo">
    <!-- 活动标题 -->
    <div v-wechat-title="'使魔计划'"></div>
    <div class="wiki_demo">
      <h3>wiki乐变导流验证页面</h3>
      <div class="form_box">
        <div class="form_item">
          <div class="form_label"><span>*</span>导流编码:</div>
          <div class="from_input">
            <input type="text" name="" v-model="guide_key" placeholder="乐变的导流编码" @focus="inputFocus()" @focusout="inputFocusOut()" />
          </div>
        </div>
        <div class="form_item">
          <div class="form_label"><span>*</span>业务分组名称:</div>
          <div class="from_input">
            <input type="text" name="" v-model="biz_name" placeholder="乐变的业务分组名称" @focus="inputFocus()" @focusout="inputFocusOut()" />
          </div>
        </div>
        <div class="form_item">
          <div class="form_label">用户id:</div>
          <div class="from_input">
            <input type="text" name="" v-model="userid" placeholder="唯一的id(例如：游戏的role_id等)" @focus="inputFocus()" @focusout="inputFocusOut()" />
          </div>
        </div>
        <div class="form_item">
          <div class="form_label">透传信息:</div>
          <div class="from_input">
            <input type="text" name="" v-model="extend" placeholder="例如：{a:1, b: 2}" @focus="inputFocus()" @focusout="inputFocusOut()" />
          </div>
        </div>
      </div>
      <a @click="getWikiLink()">生成链接</a>
      <a :href="wikiLink">打开小程序</a>
      <p>PS:修改表单值后，请点击【生成链接】，再点击【打开小程序】；<br />否则传递给小程序的参数可能是旧的</p>
    </div>

    <div class="info">
      <p>path: {{ path }}</p>
      <p>query: {{ query }}</p>
    </div>
  </div>

</template>
<script>
import axios from '@/utils/axiosHelper';
import { Toast } from "mint-ui";

export default {
  name: 'demo',
  components: {},
  data () {
    return {
      path: '/pages/game/appointment/appointment',
      query: '',
      guide_key: '',
      biz_name: '',
      userid: '',
      extend: '',
      wikiLink: '',
    };
  },
  created () {},
  mounted () {},
  computed: {},
  methods: {
    inputFocus() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
    },
    inputFocusOut() {
      this.timer = setTimeout(() => {
        window.scrollTo(0, 0);
      }, 10);
    },
    getWikiLink() {
      let query = ['guide_key', 'biz_name', 'userid', 'extend'].reduce((result, attr) => {
        if (this[attr]) {
          let val = this[attr];
          if (['biz_name', 'extend'].includes(attr)) {
            val = encodeURIComponent(this[attr]);
          }
          return `${result}&${attr}=${val}`;
        }
        return result;
      }, '');
      query = query ? query.substring(1) : '';
      const params = {
        path: this.path,
        q: query,
      };
      console.log('params', params, query);
      axios({ url: '/integral/scheme', method: 'GET', params })
        .then((res) => {
          console.log('res', res, res.data.open_like);
          const open_like = res.data.open_like;
          if (open_like) {
            this.wikiLink = open_like;
            this.query = query;
            Toast({
              message: "链接生成成功",
              duration: 1000,
              className: "toasts"
            });
          } else {
            this.query = '';
            Toast({
              message: "生成链接失败",
              duration: 1000,
              className: "toasts"
            });
          }
        });
    },
  }
};
</script>

<style lang="less" scoped>
  @import url("./index.less");
  .servitor_demo {
    .wiki_demo {
      h3 {
        padding-top: 20px;
        font-size: 40px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 20px;
      }

      .form_box {
        width: 90%;
        margin: 0 auto;
        .form_item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 60px;
          padding: 20px 0;
          .form_label {
            font-size: 30px;
            width: 240px;
            text-align: right;
            margin-right: 10px;

            span {
              color: red;
            }
          }
          .from_input {
            display: flex;
            padding-left: 10px;
            align-items: center;
            flex: 1;
            height: 100%;
            border: 1px solid #ccc;
          }
        }

        input {
          width: 100%;
        }

      }

      a {
        display: block;
        width: 90%;
        height: 70px;
        line-height: 70px;
        font-size: 30px;
        color: #fff;
        border-radius: 6px;
        margin: 0 auto;
        margin-top: 40px;
        text-align: center;
        background: #108ee6;
      }

      p {
        color: red;
        line-height: 36px;
        margin-top: 30px;
        text-align: center;
      }
    }
    .info {
      margin-top: 50px;

      p {
        margin-bottom: 20px;
        color: #666;
        font-size: 28px;
        line-height: 50px;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/pages/servitor/demo/help/index.vue